import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { Stack, Inline } from '@atlaskit/primitives/compiled';

const i18n = defineMessages({
	placeholder: {
		id: 'performance-insights.content-metrics-tab-placeholder.non-final',
		defaultMessage: 'Content metrics',
		description:
			'This is a placeholder message for the Content metrics tab, which is under development. This message is shown in the header of the Content metrics tab and is only used for basic testing. It should be replaced with meaningful content in the future.',
	},
});

const styles = cssMap({
	container: {
		width: '100%',
		marginBlockStart: token('space.300'),
	},
});

type ContentMetricsTabProps = {
	// TODO: Add props as needed
};

export const ContentMetricsTab = (_props: ContentMetricsTabProps) => {
	return (
		<>
			<Stack xcss={styles.container}>
				<Inline alignBlock="center" spread="space-between">
					<Heading size="large">
						<FormattedMessage {...i18n.placeholder} />
					</Heading>
					{/* TODO: Add filters or other header components */}
				</Inline>
				{/* TODO: Add tab content components */}
			</Stack>
		</>
	);
};
